<template>
  <v-chip
    :class="classes"
    dark
  >
    <slot/>
  </v-chip>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      require: true
    }
  },

  computed: {
    classes() {
      return {
        'subject-chip' : true,
        [`${this.type}`] : true,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.subject-chip
  width 115px
  height 18px !important
  font-size 11px !important
  font-weight bold
  display inline-block

types = {
  'kokugo': {
    'background-color': #c44c32 !important,
    'border-bottom': 1px solid #8a1c1c,
  },
  'suugaku': {
    'background-color': #3E90C6 !important,
    'border-bottom': 1px solid #225f87,
  },
  'eigo': {
    'background-color': #49A26E !important,
    'border-bottom': 1px solid #2c5e41,
  },
  'rika': {
    'background-color': #BE8540 !important,
    'border-bottom': 1px solid #875b26,
  },
  'shakai': {
    'background-color': #7DA551 !important,
    'border-bottom': 1px solid #576e3d,
  },
}

for type, values in types
  .{type}
    background-color values['background-color'];
    border-bottom values['border-bottom'];
</style>
